import { TFunction } from 'i18next';
import { Validate } from 'react-hook-form';

import { emailPattern } from '../patterns';

export const invitationRules = (t: TFunction) => ({
  emails: {
    validate: {
      minLength: (value) => {
        return value.length > 0 || t('validation.required');
      },
      emails: (value) => {
        const invalidEmails = value.reduce((acc, email) => {
          if (!emailPattern.test(email)) {
            acc.push(email);
          }
          return acc;
        }, []);
        return (
          invalidEmails.length === 0 || `${t('errors.invalid_email')}: ${invalidEmails.join(', ')}`
        );
      },
    } as Record<string, Validate<string[], unknown>>,
  },
  roles: {
    validate: {
      minLength: (value) => {
        return value.length !== 0 || t('validation.required');
      },
    },
  },
});
